export default __webpack_public_path__ + "static/media/7.c12ff248.jpeg";